import { Tooltip } from "antd";
import PropTypes from "prop-types";
import React from "react";

function UserMenu({ menuItems, toggleMenuItem }) {
    // Recursive function to render nested menus
    const getAllChildIds = (item) => {
        let ids = [item.id];
        if(item.children && item.children.length > 0) {
            item.children.forEach((child) => {
                ids = ids.concat(getAllChildIds(child));
            });
        }
        return ids;
    };

    const renderMenu = (items, level = 0) => {
        return items?.map((item) => {
            const isEnabled = item.is_enabled || 0;
            return (
                <React.Fragment key={item.id}>
                    <tr
                        className={`border hover:bg-gray-100 transition ${
                            level > 0 ? "bg-gray-50" : ""
                        }`}
                    >
                        <td className={`p-3 border pl-${level * 4}`}>
                            {"— ".repeat(level)}
                            {item.icon && (
                                <i className={`mr-2 ${item.icon}`}></i>
                            )}
                            {item.title}
                        </td>
                        <td className="p-3 border">
                            <span
                                className={`px-3 py-1 text-sm font-semibold rounded-full ${
                                    isEnabled
                                        ? "bg-green-100 text-green-700"
                                        : "bg-gray-200 text-gray-700"
                                }`}
                            >
                                {isEnabled ? "✅ Enabled" : "❌ Disabled"}
                            </span>
                        </td>
                        <td className="p-3 border">
                            <Tooltip
                                title={
                                    item.is_static == 1
                                        ? "You don't have any access to it."
                                        : ""
                                }
                                placement="right"
                            >
                                <button
                                    onClick={() => {
                                        const allIds = getAllChildIds(item);
                                        toggleMenuItem(allIds, isEnabled);
                                    }}
                                    disabled={item.is_static}
                                    className={`
                    px-3 py-1 text-sm font-medium rounded shadow-md transform transition-all duration-300 text-white
                    ${
                        item.is_static
                            ? "!bg-gray-400 !text-gray-700 !cursor-not-allowed !opacity-50"
                            : isEnabled
                              ? "bg-red-600 hover:bg-red-700"
                              : "bg-green-600 hover:bg-green-700"
                    }
                  `}
                                >
                                    {isEnabled ? "Disable" : "Enable"}
                                </button>
                            </Tooltip>
                        </td>
                    </tr>
                    {/* Render children recursively */}
                    {item?.children &&
                        item.children?.length > 0 &&
                        renderMenu(item.children, level + 1)}
                </React.Fragment>
            );
        });
    };

    return (
        <div className="mt-4">
            {/* <h3 className="text-lg font-semibold">
        Selected User: {selectedUser?.username}
      </h3> */}

            {menuItems?.length === 0 ? (
                <p className="text-center text-lg text-red-500 font-semibold mt-4">
                    No menu items found.
                </p>
            ) : (
                <div className="overflow-x-auto mt-4">
                    <table className="w-full border border-gray-300 rounded-lg overflow-hidden shadow-md">
                        <thead>
                            <tr
                                style={{ backgroundColor: "var(--navy)" }}
                                className="text-white text-left"
                            >
                                <th className="p-3 border">Title</th>
                                <th className="p-3 border">Status</th>
                                <th className="p-3 border">Actions</th>
                            </tr>
                        </thead>
                        <tbody>{renderMenu(menuItems)}</tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

UserMenu.propTypes = {
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            title: PropTypes.string,
            is_enabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
            icon: PropTypes.string,
            children: PropTypes.array,
        }),
    ).isRequired,
    toggleMenuItem: PropTypes.func.isRequired,
};

export default UserMenu;
